import Home from '../templates/HomeTemplate'

export default function HomePage() {
    return (
        <Home />
    )
}